import React, { Component, PropTypes } from 'react';

import ComponentFactory from '../../../components/utils/ComponentFactory';
import DataProvider from '../dataProvider';
import {
  NitroDrawer,
  NitroContentNotAvailable,
  NitroLoading
} from 'nitro-components';

class ProfileSidePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // this.props.actions.fetchDriverBookmarks(true);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.sidePanelData) return false;
    return true;
  }

  render() {
    const {
      sidePanelData,
      open,
      close,
      fetchingSidePanel,
      action
    } = this.props;

    let sidePanelDetailsWithHeader = {};
    let SidePanContents = [];

    if (!fetchingSidePanel && sidePanelData) {
      sidePanelDetailsWithHeader =
        sidePanelData.filter(d => d['@DisplayType'] === 'navigation-header')
          .length === 1
          ? sidePanelData
          : [
              {
                '@DisplayType': 'navigation-header',
                Title: this.props.title
              },
              ...sidePanelData
            ];

      SidePanContents =
        sidePanelData &&
        sidePanelData.length > 0 &&
        sidePanelDetailsWithHeader.map((bookmarkDetailsObj, idx) => {
          const {
            Columns,
            Rows,
            Header,
            Title,
            Footers,
            Data,
            FetchParams,
            HeaderPostFix,
            IndicatorHeader,
            ...component
          } = bookmarkDetailsObj;
          const Variant = bookmarkDetailsObj['@variant'];
          return (
            <ComponentFactory
              key={idx}
              {...{
                Columns,
                Rows,
                Header,
                Title,
                Footers,
                Data,
                title: this.props.title,
                navTitle: this.props.navTitle,
                FetchParams,
                HeaderPostFix,
                IndicatorHeader,
                Variant,
                ...component
              }}
            />
          );
        });
    }

    return (
      <NitroDrawer
        isOpen={open}
        close={close}
        width={450}
        padding="20px"
        iconVariant="white"
        closeIconSize={14}
      >
        <div>
          {!fetchingSidePanel && SidePanContents}
          {fetchingSidePanel && <NitroLoading />}
          {this.props.dataError && !fetchingSidePanel && (
            <NitroContentNotAvailable />
          )}
        </div>
      </NitroDrawer>
    );
  }
}
ProfileSidePanel.propTypes = {
  action: PropTypes.shape({}),
  sidePanelData: PropTypes.array,
  fetchingSidePanel: PropTypes.bool,
  open: PropTypes.bool,
  close: PropTypes.func,
  title: PropTypes.string
};

ProfileSidePanel.defaultProps = {
  // minimalMode: false
};

export default DataProvider(ProfileSidePanel);



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileSidePanel.js